<template>

    <div>
        <table class="table table-striped margin-bottom">
            <thead>
            <tr>
                <th>{{ lang.get('users.contracts.label.active') }}</th>
                <th>{{ lang.get('users.contracts.label.number') }}</th>
                <th>{{ lang.get('users.contracts.label.fullname') }}</th>
                <th>{{ lang.get('users.contracts.label.type') }}</th>
                <th>{{ lang.get('users.contracts.label.salary_scale') }}</th>
                <th>{{ lang.get('users.contracts.label.usergroup') }}</th>
                <th>{{ lang.get('users.contracts.label.weekly_hours') }}</th>
                <th>{{ lang.get('users.contracts.label.duration') }}</th>
                <th>{{ lang.get('users.contracts.label.start_end_date') }}</th>
                <th>{{ lang.get('users.contracts.label.salary') }}</th>
                <th>{{ lang.get('users.contracts.label.hourrate') }}</th>
                <th>&nbsp;</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="getHrUserContracts.length === 0">
                <td colspan="12">{{ lang.get('users.contracts.msg.info.no_contracts_available') }}</td>
            </tr>
            <tr v-for="contract in getHrUserContracts">
                <td v-if="contract.is_concept" colspan="2" class="text-center"><strong>{{ lang.get('global.draft').toUpperCase() }}</strong></td>
                <td v-if="!contract.is_concept">{{ contract.active === true ? 'Ja' : 'Nee' }}</td>
                <td v-if="!contract.is_concept">{{ contract.contractnumber }}</td>
                <td>{{ getHrUser.fullname }}</td>
                <td>{{ contract.type }}</td>
                <td>{{ contract.functiongroup }} {{ contract.functionyear }}</td>
                <td>{{ contract.usergroup }}</td>
                <td>{{ contract.weeklyhours }}</td>
                <td>{{ lang.get('users.contracts.duration.' + (contract.duration === 'unset' ? 'unset' : 'set')) }}</td>
                <td>
                    {{ contract.start }}
                    <span v-if="contract.end !== null">
                        &ndash; {{ contract.end }}
                    </span>
                </td>
                <td>{{ contract.salary * 100 | toCurrency }}</td>
                <td>{{ contract.hourrate * 100 | toCurrency }}</td>
                <td class="text-right">
                    <div class="btn-group btn-group-xs">
                        <router-link
                            v-if="contract.is_concept"
                            class="btn btn-info"
                            :to="{name:'hr.users.contracts.finalize', params:{uuid:getHrUser.uuid, contract_uuid: contract.uuid}}"
                            v-tooltip="lang.get('users.contracts.actions.activate_draft')"
                        >
                            <i class="fa fa-check-circle"></i>
                            <span class="sr-only">{{ lang.get('users.contracts.actions.activate_draft') }}</span>
                        </router-link>

                        <router-link
                            :to="{name:'hr.users.contracts.show', params:{uuid:getHrUser.uuid, contract_uuid: contract.uuid}}"
                            class="btn btn-default"
                            v-tooltip="lang.get('users.contracts.actions.show_contract')"
                        >
                            <i class="fa fa-eye"></i>
                            <span class="sr-only">{{ lang.get('users.contracts.actions.show_contract') }}</span>
                        </router-link>

                        <router-link
                            v-if="contract.is_concept"
                            :to="{name:'hr.users.contracts.edit', params:{uuid:getHrUser.uuid, contract_uuid: contract.uuid}}"
                            class="btn btn-primary"
                            v-tooltip="lang.get('users.contracts.actions.edit_contract')"
                        >
                            <i class="fa fa-pencil"></i>
                            <span class="sr-only">{{ lang.get('users.contracts.actions.edit') }}</span>
                        </router-link>
                        <button
                            v-else
                            class="btn btn-primary disabled"
                            v-tooltip="lang.get('users.contracts.msg.info.cannot_edit_active_contract')"
                        >
                            <i class="fa fa-pencil"></i>
                            <span class="sr-only">{{ lang.get('users.contracts.msg.info.cannot_edit_active_contract') }}</span>
                        </button>

                        <delete-button
                            v-if="contract.is_concept"
                            v-tooltip="lang.get('users.contracts.actions.remove_draft')"
                            :url="route('api.v1.hr.users.contracts.destroy', {id:getHrUser.uuid, contract_uuid:contract.uuid})"
                            title="Contract"
                            :name="lang.get('users.contracts.draft_contract')"
                            @delete-completed="$emit('updateContractdata')"
                        ></delete-button>

                        <button
                            v-if="!contract.is_concept && contract.active === true"
                            type="button"
                            class="btn btn-danger btn-sm"
                            v-tooltip="lang.get('users.contracts.actions.terminate_contract')"
                            @click="handleTerminate(contract)"
                        >
                            <i class="mdi mdi-cancel" />
                        </button>
                    </div>
                </td>
            </tr>
            </tbody>
            <tfoot>
            <tr>
                <td class="text-right" colspan="12">
                    <router-link
                        v-if="getHrUser.hasOwnProperty('usergroup')"
                        :to="{name:'hr.users.contracts.add', params: {uuid:getHrUser.uuid}}"
                        class="btn btn-primary"
                        v-tooltip="'Contract aanmaken'"
                    >
                        <i class="mdi mdi-plus"></i>
                        <span class="sr-only">Contract aanmaken</span>
                    </router-link>
                    <div v-else class="btn btn-danger" disabled>
                        Contracten kunnen pas aangemaakt worden als de gebruikersgroep gezet is.
                    </div>
                </td>
            </tr>
            <contract-terminate-modal />
            </tfoot>
        </table>
    </div>

</template>

<script>

import { mapGetters, mapActions } from "vuex";
import Hub from "../../../../Hub";
import axios from "axios";
import ContractTerminateModal from "../../../../components/HR/Users/Contracts/ContractTerminateModal";
import Lang from "../../../../Lang";

export default {

    components: {
        ContractTerminateModal,
    },

    computed:{
        ...mapGetters([
            'getHrUser',
            'getHrUserContracts',
        ]),
    },

    data() {
        return {
            lang: Lang,
        }
    },

    metaInfo: {
        title:'Contracten bekijken',
    },

    methods: {
        handleTerminate(contract) {
            Hub.$emit('show-terminate-modal', contract);
        },

        performTerminate(contract, contract_end) {
            axios.delete(this.route('api.v1.hr.users.contracts.stop', {id:this.getHrUser.uuid, contract_uuid:contract.uuid}), {data: {contract_end:contract_end}})
                .then(() => {
                    this.$snotify.success(Lang.get('users.contracts.msg.ok.terminated', {'contractNumber': contract.contractnumber}));
                    this.$emit('updateContractdata');
                })
                .catch((error) => {
                    let message = error.response.data.message
                        ?? Lang.get('users.contracts.msg.err.terminate', {'contractNumber': contract.contractnumber});
                    this.$snotify.error(message);
                });
        }
    },

    mounted() {
        this.$nextTick(function () {
            Hub.$on('perform-terminate-action', this.performTerminate);
        }.bind(this));
    },

    name:'HrUsersContractsIndex',
}

</script>
